import React, { useEffect, useState } from "react";
import axios from "axios";
import api from "../config/backend"; // Your API base URL
import './css/Category.css';
import AddIcon from '@mui/icons-material/Add';

const Category = () => {
    const [categories, setCategories] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [newCategory, setNewCategory] = useState({ name: "", description: "" });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    // Replace with your method of getting the JWT token
    const token = localStorage.getItem("_crm__token");

    // Fetch categories
    const fetchCategories = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${api}/Category/get`, { token });
            if (response.data.success) {
                setCategories(response.data.Categories);
            } else {
                setMessage(response.data.message || "Failed to fetch categories");
            }
        } catch (err) {
            setMessage("Error fetching categories");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchCategories();
        // eslint-disable-next-line
    }, []);

    // Handle form input
    const handleInput = (e) => {
        setNewCategory({ ...newCategory, [e.target.name]: e.target.value });
    };

    // Handle Add Category
    const handleAddCategory = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage("");
        try {
            const response = await axios.post(`${api}/Category/create`, {
                token,
                name: newCategory.name,
                description: newCategory.description,
            });
            if (response.data.status) {
                setMessage("Category created!");
                setShowModal(false);
                setNewCategory({ name: "", description: "" });
                fetchCategories();
            } else {
                setMessage(response.data.message || "Failed to create category");
            }
        } catch (err) {
            setMessage("Error creating category");
        }
        setLoading(false);
    };

    return (
        <div style={{ padding: 20 }} className="ppm-container">
            <div className="Category_mainHeader">
                <h2>Categories</h2>
                <button className="add-category-btn" onClick={() => setShowModal(true)}><AddIcon /> Add Category</button>
            </div>
            {message && <div style={{ color: "red", margin: "10px 0" }}>{message}</div>}
            {loading ? (
                <p>Loading...</p>
            ) : (
                <table className="category-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories.map((cat) => (
                            <tr key={cat._id}>
                                <td>{cat.name}</td>
                                <td>{cat.description}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            {/* Popup Modal */}
            {showModal && (
                <div className='app-modal-addstage'>
                    <div className='app-modal-addstage__card'>
                        <div className='app-modal-addstage__cardheader'>
                            <h3>Add Category</h3>
                            <button className="modal-close" onClick={() => setShowModal(false)}>&times;</button>
                        </div>
                        <form className="app-modal-addstage__cardbody" onSubmit={handleAddCategory}>
                            <div className='app-form__group'>
                                <div className='app-form__field'>
                                    <label className='app-form__field--label'>Name</label>
                                    <input
                                        className='app-form__field--input'
                                        type="text"
                                        name="name"
                                        value={newCategory.name}
                                        onChange={handleInput}
                                        required
                                        placeholder="Enter category name"
                                    />
                                </div>
                                <div className='app-form__field'>
                                    <label className='app-form__field--label'>Description</label>
                                    <textarea
                                        // className='app-form__field--input'
                                        name="description"
                                        value={newCategory.description}
                                        onChange={handleInput}
                                        required

                                        placeholder="Enter category description"
                                    />
                                </div>
                            </div>
                            <div className='app-modal-addstage__cardfooter'>
                                <button type="button" className='app-btn-text' onClick={() => setShowModal(false)}>
                                    Cancel
                                </button>
                                <button type="submit" className='app-btn-contained app-btn-primary'>
                                    Add
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

        </div>
    );
};

export default Category;
